import React from 'react';
import SlideLayout, { SlideTitle, SlideContent } from '../components/SlideLayout';

const ComparisonTableSlide = () => {
  return (
    <SlideLayout maxWidth="6xl">
      <SlideTitle 
        subtitle="Side-by-side comparison of reasoning approaches across vendors"
      >
        Vendor Comparison Summary
      </SlideTitle>
      
      <SlideContent>
        <div className="slide-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th>Vendor</th>
                  <th>Primary Approach</th>
                  <th>Reward Mechanism</th>
                  <th>Key Innovation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span className="font-semibold text-primary">DeepSeek</span>
                  </td>
                  <td className="text-muted-foreground">
                    <span className="text-xs px-2 py-1 rounded bg-primary/10 text-primary">Pure RL</span>
                    <span className="block text-xs mt-1">Initially without SFT</span>
                  </td>
                  <td className="text-muted-foreground">
                    <span className="text-accent">Outcome-based</span>
                    <span className="block text-xs">Rule rewards (GRPO)</span>
                  </td>
                  <td className="text-sm text-muted-foreground">
                    Emergent "Aha moments", self-correction, bypassing human priors
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="font-semibold text-secondary">OpenAI</span>
                  </td>
                  <td className="text-muted-foreground">
                    <span className="text-xs px-2 py-1 rounded bg-secondary/10 text-secondary">RLHF</span>
                    <span className="block text-xs mt-1">PPO-based</span>
                  </td>
                  <td className="text-muted-foreground">
                    <span className="text-secondary">Process Supervision</span>
                    <span className="block text-xs">Step-by-step verification</span>
                  </td>
                  <td className="text-sm text-muted-foreground">
                    Human alignment, granular step verification, reliable math
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="font-semibold text-accent">Google</span>
                  </td>
                  <td className="text-muted-foreground">
                    <span className="text-xs px-2 py-1 rounded bg-accent/10 text-accent">Prompting</span>
                    <span className="block text-xs mt-1">Few-shot exemplars</span>
                  </td>
                  <td className="text-muted-foreground">
                    <span className="text-accent">Exemplar-based</span>
                    <span className="block text-xs">No explicit reward</span>
                  </td>
                  <td className="text-sm text-muted-foreground">
                    Reasoning as emergent property of scale (>100B params)
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="font-semibold" style={{ color: 'hsl(var(--chart-4))' }}>Microsoft</span>
                  </td>
                  <td className="text-muted-foreground">
                    <span className="text-xs px-2 py-1 rounded" style={{ background: 'hsla(45, 93%, 58%, 0.1)', color: 'hsl(var(--chart-4))' }}>Synthetic Data</span>
                    <span className="block text-xs mt-1">Curriculum learning</span>
                  </td>
                  <td className="text-muted-foreground">
                    <span style={{ color: 'hsl(var(--chart-4))' }}>Quality-focused</span>
                    <span className="block text-xs">Data over quantity</span>
                  </td>
                  <td className="text-sm text-muted-foreground">
                    Small models (14B) outperform teachers with synthetic data
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="font-semibold" style={{ color: 'hsl(var(--chart-5))' }}>Qwen</span>
                  </td>
                  <td className="text-muted-foreground">
                    <span className="text-xs px-2 py-1 rounded" style={{ background: 'hsla(340, 82%, 62%, 0.1)', color: 'hsl(var(--chart-5))' }}>Self-Improve</span>
                    <span className="block text-xs mt-1">Iterative evolution</span>
                  </td>
                  <td className="text-muted-foreground">
                    <span style={{ color: 'hsl(var(--chart-5))' }}>Iterative RM</span>
                    <span className="block text-xs">Model-guided data</span>
                  </td>
                  <td className="text-sm text-muted-foreground">
                    Self-improvement from pre-training to inference
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
        <div className="grid md:grid-cols-3 gap-4 mt-6">
          <div className="p-4 rounded-xl bg-primary/10 border border-primary/20">
            <p className="text-sm">
              <strong className="text-primary">Most Novel:</strong>
              <span className="text-muted-foreground"> DeepSeek's emergent reasoning without human supervision</span>
            </p>
          </div>
          <div className="p-4 rounded-xl bg-secondary/10 border border-secondary/20">
            <p className="text-sm">
              <strong className="text-secondary">Most Reliable:</strong>
              <span className="text-muted-foreground"> OpenAI's process supervision for math tasks</span>
            </p>
          </div>
          <div className="p-4 rounded-xl bg-accent/10 border border-accent/20">
            <p className="text-sm">
              <strong className="text-accent">Most Efficient:</strong>
              <span className="text-muted-foreground"> Microsoft's data-first approach with small models</span>
            </p>
          </div>
        </div>
      </SlideContent>
    </SlideLayout>
  );
};

export default ComparisonTableSlide;
